import styled from 'styled-components'

export const Title = styled.span`
   font-size: 24px;
   font-weight: bold; 
   padding-top: 2.7rem;
   padding-bottom: 1.6rem;
   color: #252525;
`

export const Input = styled.input`
    width: 100%;
    margin-top: 1rem;
    border-radius: 0.3rem;
    border: 2px solid #000000;
    padding: 3px;
`

export const Label = styled.span`
    color: #303030;
    font-size: 16px;
    font-weight: bold;
    margin-top: 1rem;
    display: flex;
    text-align: left;
    align-items: flex-start;
`